import CustomCheckBox from "@/components/CustomCheckBox/CustomCheckBox.vue"
import UrlBlock from "@/components/UrlBlock/UrlBlock.vue"
import CustomDropdownBorder from "@/components/CustomDropdownBorder/CustomDropdownBorder.vue";
import DropdownBorderV2 from "@/components/CustomDropdownBorder/V2/DropdownV2.vue";
import Skippable from "@/components/Skippable/Skippable.vue";
import RequiredOne from "@/components/RequiredOne/RequiredOne.vue";
import Hint from "@/components/Hint/Hint.vue";
import SocialInformationTooltip from "@/components/SocialInformationTooltip/SocialInformationTooltip.vue";
import BInput from "@/components/__new_ui_kit/Input/BInput";
import SocialLink from "@/components/AccordionSocial/SocialLink/SocialLink";
import Dropdown from "@/components/__new_ui_kit/Dropdown/Dropdown";

import check from "../../../store/helpers/helper.js";

import { mapGetters, mapActions } from "vuex";
import {NEW_MODE} from "../../../utils/variables";
import Vue from "vue";

export default Vue.extend({
    props: {
        elem: {
            type: Object,
            default: () => {
                return {}
            }
        },
        isUpdate: {
            type: Boolean,
            default: false
        },
        length: {
            type: Number,
            default: () => {
                return 0
            }
        },
        last: {
            type: Number,
            default: () => {
                return 0
            }
        },
        lastActive: {
            type: Number,
            default: () => {
                return 0
            }
        },
        blocking: {
            type: Number
        },
        mode: {
            type: String,
            default: 'list' // or single
        },
        errors: {
            default: () => {
                return []
            }
        }
    },
    name: "AccordionSocialItem",
    components: {
        CustomCheckBox,
        UrlBlock,
        RequiredOne,
        CustomDropdownBorder,
        Skippable, Hint, SocialInformationTooltip,
        DropdownBorderV2,
        BInput,
        SocialLink,
        Dropdown
    },
    data() {
        return {
            item: this.$props.elem,
            arrayOrAnd: [
                {name: 'Or'},
                {name: 'And'},
            ],
            show: false,
            avatar: this.$props.elem.icon ? require(`@/assets/${(this.$props.elem.icon)}-monochrome.svg`) : require(`@/assets/avatar.svg`),
            type: '',
            btn_name_max_length: 50,
        }
    },

    created() {
        if ((this.item.check.inputs.length > 0 && this.item.icon !== 'messenger') || (this.item.check.fillable === false && this.item.status)) {
            this.show = true
        }

        this.type = {name: this.item.check.type}

        this.overwriteIcon()
    },
    methods: {
        ...mapActions(['chooseSocialForCampaign']),
        selectedAction(item, input) {
            if (input.action) {
                const selected = item.actions.find(el => el.name === input.action)
                return {...selected, value: selected.name, label: selected.name}
            } else if (item.actions) {
                const selected = item.actions[0]
                return {... selected, value: selected.name, label: selected.name}
            }
            return null
        },
        overwriteIcon() {
            if (this.$props.elem.icon) {
                let src = this.$props.elem.icon
                if (this.$props.elem.icon === 'messenger') {
                    if (this.$props.elem.name.toLowerCase() === 'telegram') {
                        src = this.$props.elem.name.toLowerCase()
                    }
                }
                this.avatar = require(`@/assets/${(src)}-monochrome.svg`)
            } else {
                this.avatar = require(`@/assets/avatar.svg`)
            }
        },
        addInp(action) {
            let maxIndex = 0;
            if (this.item.name ==='Telegram') {
                this.item.check.inputs = []
                this.item.check.inputs.push({ "id": 2, "account": "tlg"})
            }
            if (this.item.name ==='SMS') {
                this.item.check.inputs = []
                this.item.check.inputs.push({"id": 1, "account": "sms"})
            }

            if (this.item.check.inputs.length > 1) {
                maxIndex = this.item.check.inputs.reduce((a, b) => {
                    return (a.id > b.id) ? parseInt(a.id) : parseInt(b.id);
                })
            }
            if (this.item.check.inputs.length === 1) {
                maxIndex = parseInt(this.item.check.inputs[0].id);
            }

            let length = this.item.check.inputs.push({id: /*this.item.check.inputs.length*/maxIndex+1, account: '', bot_token: '', action: action, button: ''})
            return length - 1;
        },
        removeInp(item) {
            this.$emit('remove_errors_by_id', item.id)
            if (this.item.check.fillable) {
                // let index = this.item.check.inputs.lastIndexOf(item)
                let index = this.item.check.inputs.findIndex(input => input.id === item.id)
                this.item.check.inputs.splice(index, 1);
            }
        },
        accordionSocial: function (event) {
            if (this.isTapmixer()) {
                let key = false;
                let obj = event.currentTarget.closest('.accordion-item-social')
                obj.classList.toggle('accordion-item-social-active');
                obj.nextSibling.classList.toggle('and-show');
                this.show = !this.show;
                this.item.status = this.show

                if (this.item.check.fillable) {
                    this.item.check.inputs = []
                }

                if (this.item.status) {
                    key = this.addInp()
                } else {
                    this.item.check.inputs = []
                    this.$emit('update_data',this.item.sub_id)
                }
                if (key !== false) {
                    if (this.item.actions) {
                        this.item.check.inputs[key].action = (this.item.actions.length) ? this.item.actions[0].name : 'Join';
                    }
                }
                this.$emit('updateSortOnAdd', this.item);
            }
        },
        updateType(payload) {
            this.item.check.type = payload.name
        },
        getLink(payload) {
            this.$emit('removeBotTokenErrors')
            let index = this.item.check.inputs.findIndex(input => input.id === payload.id)
            this.item.check.inputs[index].account = payload.data
        },
        setBotToken(payload) {
            this.$emit('removeBotTokenChannelErrors')
            // let index = this.item.check.inputs.findIndex(input => input.id === payload.id)
            this.item.check.inputs[payload.id].bot_token = payload.data
        },
        getButton(id) {
            return (value) => {
                let index = this.item.check.inputs.findIndex(input => input.id === id)
                this.item.check.inputs[index].button = value
            }
        },
        onActionChange(payload, id) {
            let index = this.item.check.inputs.findIndex(input => input.id === id)
            this.item.check.inputs[index].action = payload.name
        },
        checkLink(link, account) {
            let result = check.checkLink(link, account);
            return result;
        },
    },
    computed: {
        ...mapGetters(['userInfo', 'getActiveSocial']),
        showItem() {
            if (this.isFanfrick()) {
                if (this.mode === 'single') {
                    return this.getActiveSocial.name.toLowerCase() === this.item.name.toLowerCase()
                }
                return false
            }
            if (this.isTapmixer()) {
                return true
            }

        },
        formattedName() {
            if (this.item.name.toLowerCase() === 'twitter') {
                return 'X (Twitter)'
            }
            return this.item.formattedName ?? this.item.name
        }
    },
    beforeMount() {
        if (process.env.VUE_APP_MODE === NEW_MODE) {
            this.chooseSocialForCampaign(this.$route.params.social.toLowerCase())
        }
    },
    mounted() {
        if (this.isFanfrick() && !this.isUpdate) {
            let elem = document.getElementsByClassName('active-single')[0]
            elem.classList.add('accordion-item-social-active')
            let key = this.addInp()
            if (key !== false) {
                if (this.item.actions) {
                    this.item.check.inputs[key].action = (this.item.actions.length) ? this.item.actions[0].name : 'Join';
                }
            }
            if (this.item.name.toLowerCase() === this.$route.params.social.toLowerCase()) {
                this.item.status = true
            }
            this.$emit('updateSortOnAdd', this.item);
        }
    }
})
